import React  from "react";
import { useGLTF } from "@react-three/drei";

export function PalletRack2P2S(props) {
  const { nodes, materials } = useGLTF("/new_models/pr_2x_2y.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Cube003.geometry}
        material={materials["Material.013"]}
      />
    </group>
  );
}

useGLTF.preload("/new_models/pr_2x_2y.glb");

export default PalletRack2P2S;
